import { useState, useEffect, useRef } from 'react';

export default function AnimatedNumber({ value, prefix = '', suffix = '', duration = 600, decimals = 2, style }) {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);
  const rafRef = useRef(null);

  useEffect(() => {
    const from = prevRef.current;
    const to = typeof value === 'number' ? value : parseFloat(value) || 0;
    if (from === to) return;

    const start = performance.now();
    const diff = to - from;

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(from + diff * eased);
      if (progress < 1) rafRef.current = requestAnimationFrame(tick);
      else { setDisplay(to); prevRef.current = to; }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  const num = typeof display === 'number' ? display : parseFloat(display) || 0;
  const formatted = num.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

  return <span style={style}>{prefix}{formatted}{suffix}</span>;
}
